import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolEInvoiceWaitingQueueContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_einvoice_waiting_queue_container.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared/api-response.model';
@Injectable({
  providedIn: 'root'
})
export class PeppolEInvoiceWaitingQueueService extends BaseApiTemplateService<PeppolEInvoiceWaitingQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'waiting-queues/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'waiting-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'waiting-queues/backoffice-ep'
    this.httpClient = http;
  }

   processNow(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
        // Get the headers from getHttpHeader
        const httpOptions = this.getHttpHeader(visa);
  
        // Add the Content-Type header
        httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
        
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'waiting-queues/process/execute/backoffice-ep'
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }
}
